/**
 * 2007-2019 PrestaShop and Contributors
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2019 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';

$(document).ready(function () {
  createProductSpin();
  createInputFile();
  coverImage();
  imageScrollBox();

  prestashop.on('updatedProduct', function (event) {
    createInputFile();
    coverImage();
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      let quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }
    imageScrollBox();
    $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
    $('.js-product-images-modal').replaceWith(event.product_images_modal);
  });

  function coverImage() {
    $('.js-thumb').on(
      'click',
      (event) => {
        $('.js-modal-product-cover').attr('src',$(event.target).data('image-large-src'));
        $('.selected').removeClass('selected');
        $(event.target).addClass('selected');
        $('.js-qv-product-cover').prop('src', $(event.currentTarget).data('image-large-src'));
      }
    );
  }

  function imageScrollBox()
  {
    if ($('#main .js-qv-product-images li').length > 2) {
      $('#main .js-qv-mask').addClass('scroll');
      $('.scroll-box-arrows').addClass('scroll');
        $('#main .js-qv-mask').scrollbox({
          direction: 'h',
          distance: 113,
          autoPlay: false
        });
        $('.scroll-box-arrows .left').click(function () {
          $('#main .js-qv-mask').trigger('backward');
        });
        $('.scroll-box-arrows .right').click(function () {
          $('#main .js-qv-mask').trigger('forward');
        });
    } else {
      $('#main .js-qv-mask').removeClass('scroll');
      $('.scroll-box-arrows').removeClass('scroll');
    }
  }

  function createInputFile()
  {
    $('.js-file-input').on('change', (event) => {
      let target, file;

      if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
        $(target).prev().text(file.name);
      }
    });
  }

  function createProductSpin()
  {
    const $quantityInput = $('#quantity_wanted');

    $quantityInput.TouchSpin({
      verticalbuttons: true,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: parseInt($quantityInput.attr('min'), 10),
      max: 1000000
    });

    $('body').on('change keyup', '#quantity_wanted', (e) => {
      $(e.currentTarget).trigger('touchspin.stopspin');
      prestashop.emit('updateProduct', {
          eventType: 'updatedProductQuantity',
          event: e
      });
    });
  }

 	// Set preferred slidesToShow
	var slidesToShow = 3;
	var childElements = $('#products_accesories').children().length;
	if (slidesToShow < childElements){
		$('#products_accesories').slick({
			infinite: true,
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			centerMode: true,
			prevArrow: '<i class="material-icons">chevron_left</i>',
			nextArrow: '<i class="material-icons">chevron_right</i>',
			responsive: [
			    {
			      breakpoint: 980,
			      settings: {
			        slidesToShow: 3,
			        slidesToScroll: 3
			      }
			    },
			    {
			      breakpoint: 600,
			      settings: {
			        slidesToShow: 2,
			        slidesToScroll: 2
			      }
			    },
			    {
			      breakpoint: 480,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1
			      }
			    }
			  ]
		});
    }
});


// Price fixed in product
$(document).ready(function(){

    if ( $(".product-summary").length > 0 ) {
        var posicion_menu_second = $('.product-summary').offset().top - $('main-menu').height() - 100;

        $(document).on('scroll', function(){
            if( $(document).scrollTop() >= posicion_menu_second ){
                if( ! $('.product-summary').hasClass('product-summary_fixed') ){
                    $('.product-summary').addClass('product-summary_fixed');
                    $('.product-summary').css('top', $('main-menu').height() + 44);
                }
            } else {
                $('.product-summary').removeClass('product-summary_fixed');
            }
        });
    }
});


posicionarMenu();

$(window).scroll(function() {    
    posicionarMenu();
});

function posicionarMenu() {
    var altura_del_header = $('.header_container').outerHeight(true);
    var altura_del_menu = $('.main-menu').outerHeight(true);

    if ($(window).scrollTop() >= altura_del_header){
        $('.main-menu').addClass('fixed');
        $('#wrapper').css('margin-top', (altura_del_menu) + 'px');
    } else {
        $('.main-menu').removeClass('fixed');
        $('#wrapper').css('margin-top', '0');
    }
}


$(document).ready(function(){
    $("#show").on( "click", function() {
      $('.top-home').show(); 
     });
    $("#ocultar").on( "click", function() {
      $('.top-home').hide(); 
    });
  });



$(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip();
});

$(document).ready(function () {
    prestashop.on('updatedProduct', function (event) {
        var quantity_html = $('#product-details .product-quantities').html();
        if (quantity_html !== undefined) {
            var quantity = $('#product-details .product-quantities span.stock').attr('data-stock');
            if (quantity > 0) {
                $('#in_stock').html('<i class="material-icons icon-image-preview">done</i>'+quantity_html+'</span>');
            } else {
                $('#in_stock').html('<i class="material-icons icon-image-preview red">close</i>'+quantity_html+'</span>');
            }
        }
    });
});

function initSlickCategoryProducts(elem) {
  elem.slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<i class="material-icons slick-arrow">chevron_left</i>',
  nextArrow: '<i class="material-icons slick-arrow">chevron_right</i>',
  responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

jQuery(function () {
  initSlickCategoryProducts($('#category_products'));
});



// WEBPACK FOOTER //
// ./js/product.js